import * as yup from 'yup';

export const schema = yup.object({
  last_name: yup.string().required('Last name is required.'),
  first_name: yup.string().required('First name is required.'),
  birth_date: yup.string().required('Birth date is required.'),
  mobile_number: yup.string().required('Mobile number is required.'),
  email: yup.string().required('Email is required.'),
  password: yup
    .string()
    .min(6, 'Atleast 6 characters')
    .required('Password is required.'),
  password_confirmation: yup
    .string()
    .oneOf([yup.ref('password')], 'Passwords do not match'),
});

export const INIT_FORM = {
  last_name: '',
  first_name: '',
  middle_name: '',
  birth_date: '',
  email: '',
  mobile_number: '',
  password: '',
  password_confirmation: '',
};
